import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroAudience, heroBadges, heroImage, heroImageAlt, stats } from '../data/copy';
import { HERO_QUALITY, HERO_SIZES, HERO_SRC_WIDTH, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function Hero() {
  return <header className="w-full bg-slate-950 [.chalk_&]:bg-slate-50" data-id="element-126" data-mp="4jm69oq8r3r3">
      {/* Mobile: promise → mockup → details. Desktop: copy left, mockup right. */}
      <div className="mx-auto grid max-w-6xl gap-x-12 px-6 pb-8 pt-8 sm:pt-12 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:pb-14 lg:pt-14" data-id="element-127" data-mp="xa4e131wttau">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-128" data-mp="sde2mt11vlvr">
          <Pill tone="accent" wrap className="max-w-sm lg:max-w-none" data-id="element-129" data-mp="nbyhz22sbhdw">{heroAudience}</Pill>

          <h1 className="mt-5 text-4xl font-extrabold uppercase leading-[1] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl [.chalk_&]:text-slate-900" style={{
          fontSize: "24px"
        }} data-id="element-130" data-mp="3d33d6tuq0lin">
            Plan your next youth basketball practice in{' '}
            <span className="text-orange-400 [.chalk_&]:text-orange-600" data-id="element-131" data-mp="3o7c0jz1umrh5">5 minutes.</span>
          </h1>
        </div>

        <div className="relative mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-132" data-mp="39b4h50y9lu2x">
          <div className="absolute inset-x-2 bottom-6 top-10 rounded-[2rem] bg-slate-900 ring-1 ring-slate-800 [.chalk_&]:bg-slate-100 [.chalk_&]:ring-slate-200" aria-hidden="true" data-id="element-133" data-mp="3e8mtl1bhqrfo" />
          <img src={optimizedImage(heroImage, HERO_SRC_WIDTH, HERO_QUALITY)} srcSet={optimizedSrcSet(heroImage, HERO_WIDTHS, HERO_QUALITY)} sizes={HERO_SIZES} alt={heroImageAlt} className="relative mx-auto w-full max-w-sm sm:max-w-xl" width={1254} height={1254} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-134" data-mp="358hmyte4fx2k" />
        </div>

        <div className="mt-6 text-center lg:col-start-1 lg:row-start-2 lg:mt-6 lg:self-start lg:text-left" data-id="element-135" data-mp="2hjyo14gyown5">
          <p className="mx-auto max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg lg:mx-0 [.chalk_&]:text-slate-600" style={{
          fontSize: "13px"
        }} data-id="element-136" data-mp="2lmuzmb833shl">
            The complete visual practice system for teaching basketball to players ages 6–12 — even if you are coaching for the first time.
          </p>

          <div className="mt-7" data-id="element-137" data-mp="i9vu7d6magq2">
            <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-138" data-mp="ddwwv03b9odi">
              Get full access now
            </CtaButton>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-139" data-mp="1ayt68yk8jhad">
            {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-sm text-slate-400 [.chalk_&]:text-slate-600" data-id="element-140" data-mp="112g4reig7z52">
                <CheckIcon className="h-4 w-4 text-orange-400 [.chalk_&]:text-orange-600" strokeWidth={2.6} aria-hidden="true" data-id="element-141" data-mp="x1w8ed5p8zjz" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-y border-slate-800 bg-slate-900 [.chalk_&]:border-slate-200 [.chalk_&]:bg-white" data-id="element-142" data-mp="3hqaj2p91pbl1">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-slate-800 px-2 sm:px-6 [.chalk_&]:divide-slate-200" data-id="element-143" data-mp="1xam5iqqvrqyx">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse px-2 py-7 text-center" data-id="element-144" data-mp="269zhpr6e2tnc">
              <dt className="mt-2 text-[0.65rem] font-semibold uppercase tracking-[0.14em] text-slate-400 sm:text-xs [.chalk_&]:text-slate-600" data-id="element-145" data-mp="26867y30hbtb4">
                {stat.label}
              </dt>
              <dd className="text-4xl font-extrabold leading-none tracking-tight text-orange-400 sm:text-5xl [.chalk_&]:text-orange-600" data-id="element-146" data-mp="2g1wyrek2wftz">
                {stat.value}
              </dd>
            </div>)}
        </dl>
        <p className="border-t border-slate-800 bg-orange-500 py-3 text-center text-xs font-bold uppercase tracking-[0.3em] text-slate-950 sm:tracking-[0.4em] [.chalk_&]:border-slate-200" data-id="element-147" data-mp="2tzlek7zagws6">
          Built for ages 6–12
        </p>
      </div>
    </header>;
}